import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileInput, RadioButtons, Checkboxes, TabPanel } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

function Open({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.OPEN.';
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext.toLocaleLowerCase() !== 'xls' && ext.toLocaleLowerCase() !== 'xlsx') {
                    showAlert(t(label + 'UPLOAD_EXCEL_ONLY'));
                    return false;
                }
                return true;
            },
            fileType: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        radioButtons: {
            data: [{
                value: 'ro',
                label: label + 'READ-ONLY'
            }, {
                value: 'rw',
                label: label + 'READ-WRITE'
            }],
            defaultValue: 'ro'
        },
        checkboxes: { label: label + 'SHEET-CONTAINS-A-HEADER' }
    }
    function handleChangeTabs(newValue) {
        if (newValue === 1) {
            action.fields.filePath.type = 'TEXT';
            delete action.fields.filePath.fileName;
            delete action.fields.filePath.byteValue;
            delete action.fields.filePath.extension;
            delete action.fields.filePath.fileSize;
            delete action.fields.filePath.value;
        } else {
            action.fields.filePath.type = 'FILE';
            delete action.fields.filePath.value;
            delete action.fields.filePath.htmlValue;
        }
        setValue(newValue);
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'FILE-PATH')}

                <div className="condition-tabs">
                    <button
                        className={value === 0 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'SELECT')}
                    </button>
                    <button
                        className={value === 1 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'CUSTOM')}
                    </button>
                </div>

                <TabPanel value={value} index={0}>
                    <FileInput action={action} inputName="filePath" options={options.fileInput} isRequired isSize={true} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="filePath" isRequired={false} setOpenVariable={setOpenVariable} variables={variables} />
                </TabPanel>
            </div>
            <div className="form-element">
                {t(label + 'OPEN-AS')}
                <RadioButtons action={action} inputName="openAs" options={options.radioButtons} isRequired />
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="sheetContains" options={options.checkboxes} />
            </div>
            <div className="form-element">
                {t(label + 'ASSIGN')}
                <VariablePicker action={action} inputName="assignToVariable" variables={variables} setOpenVariable={setOpenVariable} filter="string" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div>
    )
}

export default Open;
